export const environment = {
  production: true,
  connection: {
    name: 'LH Schaerding Softline',
    host: 'https://softline.schaerding.rlh.at/',
    port: 443,
    basePath: '/api'
  },
  androidUpdateRepository: ''
};
